/**
 * 主题管理 Hook
 * Theme Management Hook
 */

import { useState, useEffect } from 'react';

const THEME_KEY = 'app-theme';
const THEMES = {
  MODERN: 'modern',
  RETRO: 'retro',
  SKETCH: 'sketch',
  DAMAGED: 'damaged'  // 战损崩坏风
};

export const useTheme = () => {
  const [theme, setTheme] = useState(() => {
    // 从localStorage读取保存的主题，默认为手绘风格
    const savedTheme = localStorage.getItem(THEME_KEY);
    return savedTheme || THEMES.SKETCH;
  });

  useEffect(() => {
    // 应用主题到document根元素
    document.documentElement.setAttribute('data-theme', theme);

    // 保存主题到localStorage
    localStorage.setItem(THEME_KEY, theme);
  }, [theme]);

  const toggleTheme = () => {
    setTheme(prevTheme => {
      if (prevTheme === THEMES.SKETCH) return THEMES.MODERN;
      if (prevTheme === THEMES.MODERN) return THEMES.RETRO;
      if (prevTheme === THEMES.RETRO) return THEMES.DAMAGED;
      return THEMES.SKETCH;
    });
  };

  const setModernTheme = () => setTheme(THEMES.MODERN);
  const setRetroTheme = () => setTheme(THEMES.RETRO);
  const setSketchTheme = () => setTheme(THEMES.SKETCH);
  const setDamagedTheme = () => setTheme(THEMES.DAMAGED);

  return {
    theme,
    isModern: theme === THEMES.MODERN,
    isRetro: theme === THEMES.RETRO,
    isSketch: theme === THEMES.SKETCH,
    isDamaged: theme === THEMES.DAMAGED,
    toggleTheme,
    setModernTheme,
    setRetroTheme,
    setSketchTheme,
    setDamagedTheme,
    THEMES
  };
};

export default useTheme;
